import React, { useState } from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

//------------------------------------------------------------------------------

function AppInput(props) {
  const {
    className,
    placeholder,
    hiddenText,
    value,
    validationMessage,
    disabled,
    required,
  } = props

  const [focused, setIsFocused] = useState("")

  // -------------------------------------

  function onChange(event) {
    const { onChange } = props

    onChange(event.target.value)
  }

  function onBlur(event) {
    const { onBlur } = props

    setIsFocused(false)
    onBlur(event.target.value)
  }

  function handleFocus() {
    setIsFocused(true)
  }

  function getStateClass() {
    let cssClass = ""
    if (focused) {
      cssClass = "focused"
    } else {
      cssClass = value ? "valid" : ""
    }

    return cssClass
  }

  // -------------------------------------

  return (
    <div className={`${className} ${getStateClass()}`}>
      <input
        type={(hiddenText && "password") || "text"}
        value={value || ""}
        className="tm4-input"
        onChange={onChange}
        onBlur={onBlur}
        onFocus={handleFocus}
        required={required}
        disabled={disabled}
        autoComplete="off"
      />
      <label className="input-label">{placeholder}</label>

      {validationMessage && (
        <span className="validation-error-message">{validationMessage}</span>
      )}
    </div>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppInput.propTypes = {
  className: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  hiddenText: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  validationMessage: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
}

AppInput.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  validationMessage: null,
  disabled: false,
}

// ----------------------------------------------------------------------------

const StyledAppInput = styled(AppInput)`
  & {
    position: relative;

    display: flex;
    flex-direction: column;
    border-radius: 6px;
    min-height: 42px;
    height: 42px;
    max-height: 42px;
    font-size: 14px;
    max-width: 300px;
    width: 100%;
    background-color: transparent;

    overflow: hidden;

    ${(props) =>
      props.disabled &&
      css`
        cursor: not-allowed;
      `}

    .tm4-input {
      flex: 1;
      z-index: 2;
      border: 1px solid ${(props) => props.theme.colors.textSecondaryColor};
      border-radius: 6px;
      padding: 0 10px 0 10px;
      height: 42px;
      max-height: 42px;
      background-color: transparent;
      font-size: 14px;
      color: ${(props) => props.theme.colors.textPrimaryColor};

      :focus {
        outline-style: none;
        border-color: ${(props) => props.theme.colors.primaryColor} !important;
      }

      :focus,
      :valid {
        padding-top: 8px;
      }
    }

    .input-label {
      position: absolute;
      top: 50%;

      transform: translateY(-50%);

      left: 10px;
      font-size: 15px;
      color: ${(props) => props.theme.colors.textSecondaryColor};
      z-index: 1;
      transition: 0.3s ease all;
      -moz-transition: 0.3s ease all;
      -webkit-transition: 0.3s ease all;

      user-select: none;

      ${(props) =>
        props.disabled &&
        css`
          z-index: 1;
          color: #d6d6d6;
          cursor: not-allowed;
        `}
    }

    .validation-error-message {
      position: absolute;
      top: 50%;
      left: 102%;
      width: 50%;
      transform: translateY(-50%);
      font-size: 10px;
      font-weight: 600;
      color: rgb(255, 59, 48);
    }

    /* MOBILE */
    @media (max-width: ${(props) => props.theme.screenSizes.mobile}px) {
      .validation-error-message {
        position: absolute;
        top: 101%;
        left: 10px;
        width: 100%;
        transform: unset;
        line-height: 1;
      }
    }
  }

  &.focused {
    .input-label {
      position: absolute;
      top: 8.5px;
      font-size: 10px;
      font-weight: 600;
      color: ${(props) => props.theme.colors.primaryColor};
    }
  }

  &.valid {
    .input-label {
      position: absolute;
      top: 8.5px;
      font-size: 10px;
      font-weight: 600;
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledAppInput
